// Imports => Constants
import { ENDPOINTS } from '@constants';

export class PagesAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  list() {
    return this.Client.get(ENDPOINTS.PAGES.INDEX)
      .then((response) => response.data.data)
      .catch((error) => {
        throw error;
      });
  }

  single(slug) {
    return this.Client.get(ENDPOINTS.PAGES.SHOW(slug))
      .then((response) => response.data.data)
      .catch((error) => {
        throw error;
      });
  }
}

export default PagesAPI;
